import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Box, Text, Flex } from '@chakra-ui/react'
import { isEmpty } from 'src/utils/helpers'
import intlMessagesApp from 'src/modules/App/translations'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import styles from './ContactSummary.module.less'

class ContactSummary extends Component {
  handleCall = phone => window.open(`tel:${phone}`, '_self')
  handleEmail = email => window.open(`mailto:${email}`)
  handleKeyDown = cb => {
    return e => {
      const keyDown = e.key !== undefined ? e.key : e.keyCode
      if (keyDown === 'Enter' || keyDown === 13) {
        cb(e)
      }
    }
  }
  render() {
    const { intl, className, data, companyData } = this.props

    if (isEmpty(data)) {
      return ''
    }

    const cxCard = cx({
      [styles.card]: true,
      [className]: !!className,
    })

    const hasPhone = data.hasOwnProperty('phone') && data.phone
    const hasEmail = data.hasOwnProperty('email') && data.email

    return (
      <Box mt={'16px'} className={cxCard}>
        <Flex direction={'column'} align={'center'} justify={'center'}>
          {data.hasOwnProperty('photo') && (
            <Box mt={'16px'} className={styles.photoHolder}>
              <img src={data.photo} alt='Logo' className={styles.image} />
            </Box>
          )}

          <Box px={'16px'}>
            {data.hasOwnProperty('name') && data.name ? (
              <Text fontSize={'18px'} fontWeight={'bold'}>
                {data.name}
              </Text>
            ) : (
              ''
            )}
            {data.hasOwnProperty('email') && data.email ? (
              <Text opacity={0.8} fontSize={'14px'}>
                {data.email}
              </Text>
            ) : (
              ''
            )}
            {companyData.hasOwnProperty('address') && companyData.address ? (
              <Text mt={'16px'} opacity={0.8} fontSize={'14px'}>
                {companyData.address}
              </Text>
            ) : (
              ''
            )}
          </Box>
        </Flex>

        <Flex mt={'20px'} borderTop={'1px'} borderTopColor={'#E2E8F0'}>
          {hasPhone ? (
            <Flex
              onClick={() => this.handleCall(data.phone)}
              cursor={'pointer'}
              p={'8px'}
              justify={'center'}
              align={'center'}
              flex={1}
            >
              <FontAwesomeIconComponent icon={['far', 'phone-arrow-up-right']} size='xs' />
              <Text
                ml={'9px'}
                tabIndex='0'
                onKeyDown={this.handleKeyDown(() => this.handleCall(data.phone))}
              >
                {' '}
                {intl.formatMessage(intlMessagesApp.appGlobalPhonesCall)}
              </Text>
            </Flex>
          ) : null}

          {hasPhone && hasEmail ? <Box width={'1px'} backgroundColor={'#E2E8F0'} /> : null}

          {hasEmail ? (
            <Flex
              onClick={() => this.handleEmail(data.email)}
              cursor={'pointer'}
              p={'8px'}
              justify={'center'}
              align={'center'}
              flex={1}
            >
              <FontAwesomeIconComponent icon={['far', 'envelope']} size='xs' />
              <Text
                ml={'9px'}
                tabIndex='0'
                onKeyDown={this.handleKeyDown(() => this.handleEmail(data.email))}
              >
                {intl.formatMessage(intlMessagesApp.appGlobalEmail)}
              </Text>
            </Flex>
          ) : null}
        </Flex>
      </Box>
    )
  }
}

ContactSummary.propTypes = {
  intl: PropTypes.object,
  className: PropTypes.string,
  data: PropTypes.object,
}

export default injectIntl(ContactSummary)
